import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import MenuWorkShopItems from '~/components/Molecules/MenuWorkShopItems.vue';
import MobileMenuItemGraphql from '~/components/Atoms/MobileMenuItemGraphql.vue';
import StoreLocaleSelector from '~/components/Layout/StoreLocaleSelector/StoreLocaleSelector.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import MenuSidebarSecondLevelGraphql from '~/components/Molecules/MenuSidebarSecondLevelGraphql.vue';
import MenuSidebarThirdLevelGraphql from '~/components/Molecules/MenuSidebarThirdLevelGraphql.vue';
import { useUser } from '~/composables/_next/useUser';
import useMenu from '~/composables/useMenu';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarMenuOrganism',
  props: {
    menuItems: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;
    var _useUser = useUser(),
      user = _useUser.user;
    var firstName = computed(function () {
      var _user$value$firstName, _user$value;
      return (_user$value$firstName = (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.firstName) !== null && _user$value$firstName !== void 0 ? _user$value$firstName : '';
    });
    var sidebarRef = ref(null);
    var menuDepth = ref(0);
    var oldDepth = ref(0);
    var previousCategory = ref({});
    var selectedCategory = ref({});
    var handleAccountClick = function handleAccountClick() {
      navigateToOrLogin({
        nextRoutePath: 'my-account',
        previousRoutePath: route.path
      });
    };
    watch(menuDepth, function (_, old) {
      return oldDepth.value = old;
    });
    watch(function () {
      return route.fullPath;
    }, function () {
      closeMenu();
    });
    var mainItems = computed(function () {
      var _props$menuItems$item, _props$menuItems, _props$menuItems$item2;
      return (_props$menuItems$item = (_props$menuItems = props.menuItems) === null || _props$menuItems === void 0 ? void 0 : (_props$menuItems$item2 = _props$menuItems.itemsCollection) === null || _props$menuItems$item2 === void 0 ? void 0 : _props$menuItems$item2.items) !== null && _props$menuItems$item !== void 0 ? _props$menuItems$item : [];
    });
    var filteredMainItems = computed(function () {
      return mainItems.value.filter(function (_ref2) {
        var type = _ref2.type;
        return (type === null || type === void 0 ? void 0 : type.toLowerCase()) !== 'highlight';
      });
    });
    var highlightedMainItems = computed(function () {
      return mainItems.value.filter(function (_ref3) {
        var type = _ref3.type;
        return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'highlight';
      });
    });
    var learnItems = computed(function () {
      var _props$menuItems$lear, _props$menuItems2, _props$menuItems2$lea;
      return (_props$menuItems$lear = (_props$menuItems2 = props.menuItems) === null || _props$menuItems2 === void 0 ? void 0 : (_props$menuItems2$lea = _props$menuItems2.learnLinksCollection) === null || _props$menuItems2$lea === void 0 ? void 0 : _props$menuItems2$lea.items) !== null && _props$menuItems$lear !== void 0 ? _props$menuItems$lear : [];
    });

    /**
     * Sets the selected category and menu depth.
     *
     * @param      {Object}  category  The category
     * @param      {Integer}  depth     The menu depth
     */
    function setSelectedCategory(category, depth) {
      previousCategory.value = JSON.parse(JSON.stringify(selectedCategory.value));
      selectedCategory.value = category;
      menuDepth.value = depth;
    }

    /**
     * Gets the sub items.
     *
     * @param      {Object}  item    The parent item
     * @return     {Array}  The sub items.
     */
    function getSubItems(item) {
      var _item$subItemsCollect, _item$subItemsCollect2;
      return (_item$subItemsCollect = item === null || item === void 0 ? void 0 : (_item$subItemsCollect2 = item.subItemsCollection) === null || _item$subItemsCollect2 === void 0 ? void 0 : _item$subItemsCollect2.items) !== null && _item$subItemsCollect !== void 0 ? _item$subItemsCollect : [];
    }

    /**
     * Gets the marketing banners.
     *
     * @param      {Object}  item    The parent item
     * @return     {Array}  The banners.
     */
    function getMarketingBanner(item) {
      var _item$marketingBanner, _item$marketingBanner2;
      return (_item$marketingBanner = item === null || item === void 0 ? void 0 : (_item$marketingBanner2 = item.marketingBannersCollection) === null || _item$marketingBanner2 === void 0 ? void 0 : _item$marketingBanner2.items) !== null && _item$marketingBanner !== void 0 ? _item$marketingBanner : [];
    }

    /**
     * Returns to previous navigation level.
     * If there's no `selectedCategory` it means that we are in the "workshop" level
     * and that we need to go back to the root depth.
     */
    function returnToPreviousLevel() {
      if (!selectedCategory.value) {
        setSelectedCategory(null, 0);
      } else {
        setSelectedCategory(previousCategory.value, menuDepth.value - 1);
      }
    }

    /**
     * Closes the menu and returns it to the initial depth
     */
    function closeMenu() {
      var _sidebarRef$value, _sidebarRef$value$sid;
      menuDepth.value = 0;
      (_sidebarRef$value = sidebarRef.value) === null || _sidebarRef$value === void 0 ? void 0 : (_sidebarRef$value$sid = _sidebarRef$value.sidebar) === null || _sidebarRef$value$sid === void 0 ? void 0 : _sidebarRef$value$sid.close();
    }
    onBeforeUnmount(function () {
      closeMenu();
    });
    provide('close', closeMenu);
    expose({
      sidebarRef: sidebarRef
    });
    return {
      __sfc: true,
      props: props,
      navigateToOrLogin: navigateToOrLogin,
      route: route,
      i18n: i18n,
      getMenuItemLink: getMenuItemLink,
      user: user,
      firstName: firstName,
      sidebarRef: sidebarRef,
      menuDepth: menuDepth,
      oldDepth: oldDepth,
      previousCategory: previousCategory,
      selectedCategory: selectedCategory,
      handleAccountClick: handleAccountClick,
      mainItems: mainItems,
      filteredMainItems: filteredMainItems,
      highlightedMainItems: highlightedMainItems,
      learnItems: learnItems,
      setSelectedCategory: setSelectedCategory,
      getSubItems: getSubItems,
      getMarketingBanner: getMarketingBanner,
      returnToPreviousLevel: returnToPreviousLevel,
      closeMenu: closeMenu,
      AzIcon: AzIcon,
      MenuWorkShopItems: MenuWorkShopItems,
      MobileMenuItemGraphql: MobileMenuItemGraphql,
      StoreLocaleSelector: StoreLocaleSelector,
      AzSidebar: AzSidebar,
      MenuSidebarSecondLevelGraphql: MenuSidebarSecondLevelGraphql,
      MenuSidebarThirdLevelGraphql: MenuSidebarThirdLevelGraphql
    };
  }
});